/**
   Copyright (c)2021 3Key Company s.r.o., All Rights Reserved

   It is strictly prohibited to distribute the source code,
   transpiled and compiled code or its parts without previous
   agreement of the 3Key Company board.
*/

import logo from "images/Logo.svg";
import "./NavBar.css";

import React from "react";

import { bindActionCreators, Dispatch } from "@reduxjs/toolkit";
import { connect } from "react-redux";

import { CompaniesState, slice as companiesSlice } from "store/company/companies.slice";
import { AssetGroupsState, slice as assetGroupSlice } from "store/company/assetGroups.slice";

import Context from "lib/context";
import ServicesContext from "services/ServicesContext";

import { NavBarProps, NavBarState } from "./NavBar.types";

import Navbar from "components/ThreeKey/Layouts/FlatLogicOneBased/Navbar";
import InputDropDown from "components/ThreeKey/InputDropDown";
import CompanySettings from "../CompanySettings/CompanySettings";
import MessageBox from "components/ThreeKey/Dialogs/MessageBox";

class NavBar extends React.Component<NavBarProps, NavBarState> {

   static contextType = Context;
   public context!: ServicesContext;

   private _sessionTimer?: number;

   constructor(props: NavBarProps) {

      super(props);

      const state: NavBarState = {
         companiesSettingsShown: false,
         sessionTimeout:  `00:00`,
         sessionTimeoutDialogShown: false
      }

      this.state = state;

   }

   private calcSessionTimeout() {

      let d = this.context.api.auth_expires - Date.now();
      if (d < 0) d = 0;

      const dtd = new Date(d);

      let m = dtd.getMinutes().toString();
      if (m.length < 2) m = "0" + m;

      let s = dtd.getSeconds().toString();
      if (s.length < 2) s = "0" + s;

      this.setState({
         sessionTimeout: `${m}:${s}`
      })

      if (d <= 0) {
         this.setState({
            sessionTimeoutDialogShown: true
         })
      }

   }

   componentWillMount() {
      this.calcSessionTimeout();
   }

   componentDidMount() {

      this._sessionTimer = setInterval(
         () => {
            this.calcSessionTimeout();
         },
         1000
      ) as any as number;

   }

   componentWillUnmount() {

      clearInterval(this._sessionTimer);

   }

   public render(): React.ReactNode {

      const sessionTimeoutDialog = !this.state.sessionTimeoutDialogShown ? <></> :
         <MessageBox
            caption="Your session has expired."
            message="Please login again."
            cancelOnEscape={false}
            cancelOnOverlayMouseDown={false}
            okText="Login"
            onOk={() => this.context.api.auth?.login("/radar")}
         />

      const dialog = !this.state.companiesSettingsShown ? <></> :
         <CompanySettings onClose={ () => this.setState({ companiesSettingsShown: false }) } />;

      return (

         <Navbar>

            {dialog}
            {sessionTimeoutDialog}

            <div className="navbar-items">

               <div className="navbar-item-logo">
                  <img className="logo" src={logo} alt="CVE Radar" />
               </div>

               <div className="navbar-item-company navbar-named-drop-down-item">

                  <InputDropDown
                     componentName={"company"}
                     items={this.props.companies.companies?.map(c => c.companyName).sort()}
                     value={this.props.companies.selectedCompany ? this.props.companies.selectedCompany.companyName : ""}
                     onChange={this.onCompanyDropDownChange}
                     readOnly={true}
                     isLoading={this.props.companies.companiesLoading}
                     dropDownOnFocus={true}
                  />

               </div>

               <div className="navbar-item-icon-settings" title="Settings" onMouseDown={this.companySettingsMouseDown}>
                  <div className="icon"></div>
               </div>

               <div className="navbar-item-icon-user">
                  <div className="icon">
                  </div>

                  <div className="user-menu">

                     <div className="container">

                        <ul>
                           <li>
                              <div>{this.context.api.auth?.getAuthenticatedUser()}</div>
                           </li>
                        </ul>

                        <ul>
                           <li></li>
                           <li><a href="/" onClick={(e) => { this.context.api.auth?.logout("/"); e.preventDefault(); }}>Logout</a></li>
                        </ul>

                     </div>
                  </div>

               </div>

               <div className="navbar-item-icon-help" title="Help" onMouseDown={() => { if (this.props.onHelpClick) this.props.onHelpClick() }}>
                  <div className="icon"></div>
               </div>


{/*
               <div className="navbar-item-session" title="Session expiration time">
                  {this.state.sessionTimeout}
               </div>
*/}


            </div>

         </Navbar>

      )

   }


   private onCompanyDropDownChange = (companyName: string) => {

      this.props.actions.selectCompanyByName({ companyName });

   }

   private companySettingsMouseDown = () => {

      this.setState({
         companiesSettingsShown: true
      })

   }

}


const mapStateToProps = (state: {
   companies: CompaniesState,
   assetGroups: AssetGroupsState
}) => {

   return state;

}


const mapDispatchToProps = (dispatch: Dispatch) => {

   return {
      actions: bindActionCreators(
         Object.assign(
            {},
            companiesSlice.actions,
            assetGroupSlice.actions
         ),
         dispatch
      )
   }

}


export default connect(
   mapStateToProps,
   mapDispatchToProps
)(NavBar);